import store from '../store';

export default relationalId => {
  const divisions = store.getState().divisions.byId;
  const included = {};
  const excluded = {};

  for(const division of Object.values(divisions)) {
    if(division.isDeleted) continue;
    if(
      (division.properties.byId[relationalId] && !division.properties.byId[relationalId].isDeleted) || 
      (division.users.byId[relationalId] && !division.users.byId[relationalId].isDeleted)) {
      included[division.divisionId] = division;
    } else {
      excluded[division.divisionId] = division;
    }
  }
  return { included, excluded };
}